import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

export namespace ApiTaCt060 {
  // GET parameters
  export namespace Get {
    // API Request
    export interface Request {
      // 成績表総合画面から遷移する場合は前者のパラメータを、
      // もくじ画面から遷移する場合は後者のパラメータを用いる
      query:
        | {
            answerCommentaryId: string // 答案ID
          }
        | {
            unitId: string // 配信単位ID
            subunitId: string // 単元ID
            pieceId: string // コマID
          }
    }

    // API Response
    export interface Response {
      contentUrl: string
    }
  }

  // API Path
  const path: string = '/ta/unitQuestions'

  // API本体
  export class Api extends ApiBase implements Gettable<Get.Request, Get.Response, ResponseError> {
    // GET
    public get<R>(
      params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造サンプル
      const validationSample: Get.Response = {
        contentUrl: '',
      }

      // エラー時のレスポンス構造サンプル
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      // API呼び出し
      return this.callbackWrapper<Get.Response, ResponseError, R>(
        api.get<Get.Response>(path, { params: params.query }),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
